"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.form.title.edit': 'Edytuj wiedzę',
    'knowledge.form.title.add': 'Dodaj wiedzę',
    'knowledge.form.back': 'Wstecz',
    'knowledge.form.title.label': 'Tytuł',
    'knowledge.form.title.placeholder': 'Wprowadź tytuł wiedzy',
    'knowledge.form.description.label': 'Opis',
    'knowledge.form.description.placeholder': 'Wprowadź opis wiedzy',
    'knowledge.form.description.help': 'Podaj krótki opis, aby pomóc w identyfikacji tej wiedzy',
    'knowledge.form.content.label': 'Treść',
    'knowledge.form.content.placeholder': 'Wprowadź treść wiedzy',
    'knowledge.form.file.label': 'Plik',
    'knowledge.form.file.placeholder': 'Wybierz plik',
    'knowledge.form.project.label': 'Projekt',
    'knowledge.form.project.placeholder': 'Wybierz projekt',
    'knowledge.form.tags.label': 'Tagi',
    'knowledge.form.tags.placeholder': 'Wprowadź tagi oddzielone przecinkami',
    'knowledge.form.tags.help': 'Użyj Enter aby dodać tagi',
    'knowledge.form.contentType.label': 'Typ treści',
    'knowledge.form.contentType.help': 'Wybierz typ treści, którą chcesz dodać',
    'knowledge.form.contentType.text': 'Tekst',
    'knowledge.form.contentType.file': 'Plik',
    'knowledge.form.contentType.link': 'Link',
    'knowledge.form.contentType.googleDrive': 'Google Drive',
    'knowledge.form.contentType.google-drive': 'Google Drive',
    'knowledge.form.link.label': 'URL linku',
    'knowledge.form.link.placeholder': 'Wprowadź URL linku',
    'knowledge.form.googleDrive.label': 'URL Google Drive',
    'knowledge.form.googleDrive.placeholder': 'Wprowadź URL udostępniania Google Drive',
    'knowledge.form.googleDrive.selectFile': 'Wybierz z Google Drive',
    'knowledge.form.googleDrive.notAuthenticated': 'Google Drive nie połączony. Proszę połączyć konto w ustawieniach.',
    'knowledge.form.googleDrive.notConnected': 'Google Drive nie połączony',
    'knowledge.form.googleDrive.connect': 'Połącz w Ustawieniach',
    'knowledge.form.googleDrive.configureSettings': 'Skonfiguruj w Ustawieniach',
    'knowledge.form.googleDrive.statusError': 'Błąd sprawdzania statusu Google Drive',
    'knowledge.form.googleDrive.fileSelected': 'Plik Google Drive został pomyślnie wybrany',
    'knowledge.form.googleDrive.fileCleared': 'Plik Google Drive został usunięty',
    'knowledge.form.timed.label': 'Włącz dostępność czasową',
    'knowledge.form.timed.help': 'Ogranicz kiedy ta wiedza jest dostępna dla awatarów',
    'knowledge.form.startTime.label': 'Czas rozpoczęcia',
    'knowledge.form.startTime.placeholder': 'Wybierz datę rozpoczęcia',
    'knowledge.form.endTime.label': 'Czas zakończenia',
    'knowledge.form.endTime.placeholder': 'Wybierz datę zakończenia',
    'knowledge.form.active.label': 'Aktywny',
    'knowledge.form.active.help': 'Włącz tę wiedzę do użytku',
    'knowledge.form.rag_status.label': 'Status RAG',
    'knowledge.form.content_type.label': 'Typ Zawartości',
    'knowledge.form.submit.update': 'Zaktualizuj wiedzę',
    'knowledge.form.submit.create': 'Utwórz wiedzę',
    'knowledge.form.reset.debug': 'Resetowanie formularza do stanu początkowego',
    'knowledge.form.reset.complete': 'Resetowanie części formularza zakończone',
    'knowledge.form.reset.forNext': 'Resetowanie formularza dla następnego wpisu',
    'knowledge.form.projects.loadError': 'Błąd ładowania projektów:',
    'knowledge.form.load.error': 'Błąd ładowania wiedzy',
    'knowledge.form.submit.duplicateWarning': 'Wysyłanie formularza już w toku, ignorowanie duplikatu wysyłania',
    'knowledge.form.submit.starting': 'Rozpoczynanie wysyłania formularza z danymi:',
    'knowledge.form.submit.updating': 'Aktualizowanie wiedzy z ID:',
    'knowledge.form.submit.creating': 'Tworzenie nowego wpisu wiedzy',
    'knowledge.form.submit.updateError': 'Błąd aktualizowania wiedzy',
    'knowledge.form.submit.createError': 'Błąd tworzenia wiedzy',
    'knowledge.form.submit.updateSuccess': 'Wiedza zaktualizowana pomyślnie',
    'knowledge.form.submit.createSuccess': 'Wiedza utworzona pomyślnie',
    'knowledge.form.submit.success': 'Wiedza utworzona pomyślnie:',
    'knowledge.form.submit.error': 'Błąd zapisywania wiedzy:',
    'knowledge.form.validation.fileRequired': 'Plik jest wymagany',
    'knowledge.form.validation.timedDatesRequired': 'Zarówno czas rozpoczęcia, jak i zakończenia są wymagane gdy włączona jest opcja czasowa',
    'knowledge.form.fileProcessing.completed': 'Przetwarzanie pliku zakończone pomyślnie',
    'knowledge.form.fileProcessing.failed': 'Przetwarzanie pliku nie powiodło się',
    'knowledge.form.ragOverride.title': 'Nadpisanie ustawień indeksowania',
    'knowledge.form.ragOverride.description': 'Opcjonalnie nadpisz domyślne ustawienia indeksowania RAG dla tego wpisu wiedzy.',
};
